export const COUNTRY_TO_LANGUAGE = {
  // --- UKRAINIAN (ua) ---
  UA: "ua",

  // --- RUSSIAN (ru) ---
  RU: "ru",
  BY: "ru",
  KZ: "ru",
  KG: "ru",
  UZ: "ru",
  TJ: "ru",
  TM: "ru",
  AM: "ru",
  AZ: "ru",

  // --- SPANISH (es) ---
  ES: "es", // Spain
  MX: "es", // Mexico
  AR: "es", // Argentina
  CO: "es", // Colombia
  PE: "es", // Peru
  VE: "es", // Venezuela
  CL: "es", // Chile
  EC: "es", // Ecuador
  GT: "es", // Guatemala
  CU: "es", // Cuba
  BO: "es", // Bolivia
  DO: "es", // Dominican Republic
  HN: "es", // Honduras
  PY: "es", // Paraguay
  SV: "es", // El Salvador
  NI: "es", // Nicaragua
  CR: "es", // Costa Rica
  PA: "es", // Panama
  UY: "es", // Uruguay
  GQ: "es", // Equatorial Guinea
  PT: "es",

  // --- ENGLISH (en) - FALLBACK FOR EVERYONE ELSE ---

  // Western/Northern Europe
  FR: "en",
  DE: "en",
  IT: "en",
  NL: "en",
  BE: "en",
  CH: "en",
  AT: "en",
  SE: "en",
  NO: "en",
  DK: "en",
  FI: "en",
  GR: "en",
  IE: "en",
  GB: "en",
  IS: "en",

  // Central/Eastern Europe (Fallback to En)
  CZ: "en",
  HU: "en",
  RO: "en",
  BG: "en",
  SK: "en",
  HR: "en",
  RS: "en",
  SI: "en",
  BA: "en",
  AL: "en",
  EE: "en",
  LV: "en",
  LT: "en",
  PL: "en",
  MD: "en",

  // Asia / Pacific
  JP: "en",
  CN: "en",
  KR: "en",
  VN: "en",
  TH: "en",
  ID: "en",
  IN: "en",
  PK: "en",
  BD: "en",
  PH: "en",
  MY: "en",
  SG: "en",
  HK: "en",
  TW: "en",
  AU: "en",
  NZ: "en",

  // Americas (Non-Spanish)
  US: "en",
  CA: "en",
  BR: "en",

  // Middle East
  TR: "en",
  AE: "en",
  SA: "en",
  QA: "en",
  KW: "en",
  EG: "en",
  IL: "en",

  // Africa
  ZA: "en",
  NG: "en",
  KE: "en",
  MA: "en",
};

export const TIMEZONE_TO_LANGUAGE = {
  // --- UKRAINIAN (ua) ---
  "Europe/Kiev": "ua",
  "Europe/Kyiv": "ua",
  "Europe/Uzhgorod": "ua",
  "Europe/Zaporozhye": "ua",

  // --- RUSSIAN (ru) ---
  // Russia
  "Europe/Moscow": "ru",
  "Europe/Volgograd": "ru",
  "Europe/Samara": "ru",
  "Europe/Saratov": "ru",
  "Europe/Ulyanovsk": "ru",
  "Europe/Kirov": "ru",
  "Europe/Astrakhan": "ru",
  "Europe/Kaliningrad": "ru",
  "Asia/Yekaterinburg": "ru",
  "Asia/Omsk": "ru",
  "Asia/Novosibirsk": "ru",
  "Asia/Barnaul": "ru",
  "Asia/Tomsk": "ru",
  "Asia/Novokuznetsk": "ru",
  "Asia/Krasnoyarsk": "ru",
  "Asia/Irkutsk": "ru",
  "Asia/Chita": "ru",
  "Asia/Yakutsk": "ru",
  "Asia/Vladivostok": "ru",
  "Asia/Magadan": "ru",
  "Asia/Sakhalin": "ru",
  "Asia/Kamchatka": "ru",
  // CIS / Post-Soviet (Mapping to 'ru' as common lingua franca or specific logic)
  "Europe/Minsk": "ru", // Belarus
  "Asia/Almaty": "ru", // Kazakhstan
  "Asia/Qyzylorda": "ru",
  "Asia/Aqtobe": "ru",
  "Asia/Aqtau": "ru",
  "Asia/Oral": "ru",
  "Asia/Tashkent": "ru", // Uzbekistan
  "Asia/Dushanbe": "ru", // Tajikistan
  "Asia/Bishkek": "ru", // Kyrgyzstan
  "Asia/Ashgabat": "ru", // Turkmenistan
  "Asia/Yerevan": "ru", // Armenia
  "Asia/Baku": "ru", // Azerbaijan

  // --- SPANISH (es) ---
  // Europe
  "Europe/Madrid": "es",
  "Europe/Lisbon": "es",
  "Atlantic/Canary": "es",
  // Mexico
  "America/Mexico_City": "es",
  "America/Monterrey": "es",
  "America/Tijuana": "es",
  "America/Merida": "es",
  "America/Chihuahua": "es",
  "America/Mazatlan": "es",
  // South America
  "America/Bogota": "es", // Colombia
  "America/Lima": "es", // Peru
  "America/Caracas": "es", // Venezuela
  "America/Santiago": "es", // Chile
  "America/Argentina/Buenos_Aires": "es", // Argentina
  "America/Argentina/Cordoba": "es",
  "America/Argentina/Mendoza": "es",
  "America/Montevideo": "es", // Uruguay
  "America/Asuncion": "es", // Paraguay
  "America/La_Paz": "es", // Bolivia
  "America/Guayaquil": "es", // Ecuador
  // Central America & Caribbean
  "America/Havana": "es", // Cuba
  "America/Santo_Domingo": "es", // Dominican Republic
  "America/Guatemala": "es",
  "America/Costa_Rica": "es",
  "America/Panama": "es",
  "America/El_Salvador": "es",
  "America/Tegucigalpa": "es", // Honduras
  "America/Managua": "es", // Nicaragua
  "America/Puerto_Rico": "es",
  "America/Sao_Paulo": "es",
  "America/Rio_Branco": "es",
  "America/Manaus": "es",
  "America/Belem": "es",
  "America/Recife": "es",
  "America/Fortaleza": "es",
  "America/Bahia": "es",

  // --- ENGLISH (en) - FALLBACK & GLOBAL HUBS ---

  // USA & Canada
  "America/New_York": "en",
  "America/Detroit": "en",
  "America/Chicago": "en",
  "America/Indiana/Indianapolis": "en",
  "America/Denver": "en",
  "America/Phoenix": "en",
  "America/Los_Angeles": "en",
  "America/Anchorage": "en",
  "Pacific/Honolulu": "en",
  "America/Toronto": "en",
  "America/Vancouver": "en",
  "America/Edmonton": "en",
  "America/Winnipeg": "en",
  "America/Halifax": "en",
  "America/St_Johns": "en",

  // Europe (Non-ES/RU/UA)
  "Europe/London": "en",
  "Europe/Dublin": "en",
  "Europe/Paris": "en",
  "Europe/Berlin": "en",
  "Europe/Rome": "en",
  "Europe/Amsterdam": "en",
  "Europe/Brussels": "en",
  "Europe/Stockholm": "en",
  "Europe/Oslo": "en",
  "Europe/Copenhagen": "en",
  "Europe/Helsinki": "en",
  "Europe/Zurich": "en",
  "Europe/Vienna": "en",
  "Europe/Warsaw": "en",
  "Europe/Prague": "en",
  "Europe/Budapest": "en",
  "Europe/Bucharest": "en",
  "Europe/Sofia": "en",
  "Europe/Athens": "en",
  "Europe/Istanbul": "en",
  "Asia/Tbilisi": "en",
  "Europe/Chisinau": "en",

  // Asia / Middle East
  "Asia/Tokyo": "en",
  "Asia/Shanghai": "en",
  "Asia/Hong_Kong": "en",
  "Asia/Taipei": "en",
  "Asia/Seoul": "en",
  "Asia/Singapore": "en",
  "Asia/Kuala_Lumpur": "en",
  "Asia/Manila": "en",
  "Asia/Jakarta": "en",
  "Asia/Bangkok": "en",
  "Asia/Ho_Chi_Minh": "en",
  "Asia/Dubai": "en",
  "Asia/Riyadh": "en",
  "Asia/Jerusalem": "en",
  "Asia/Kolkata": "en", // India

  // Australia / NZ
  "Australia/Sydney": "en",
  "Australia/Melbourne": "en",
  "Australia/Brisbane": "en",
  "Australia/Adelaide": "en",
  "Australia/Perth": "en",
  "Australia/Darwin": "en",
  "Pacific/Auckland": "en",

  // Africa
  "Africa/Johannesburg": "en",
  "Africa/Lagos": "en",
  "Africa/Cairo": "en",
  "Africa/Nairobi": "en",
};
